import type { Staff } from "@/lib/authv2/store";
import { ACTION } from "@/lib/auth/actions";
import { hasPermission } from "@/lib/authv2/permissions";

// Hai quyền tách rời có chủ đích (quy chế KPI doanh thu chi nhánh 19/08/2026):
// XEM mở rộng tới cả nhân viên tiệm — quy chế chia 50% quỹ vượt cho đội, đội
// không thấy tiệm mình đang đạt bao nhiêu thì cơ chế thưởng vô nghĩa. GIAO KPI
// thì chỉ CEO/admin: người bị chấm không được tự đặt mức chấm mình.
//
// Phạm vi chi nhánh do backend cắt (auth.BranchScope), không phải do màn hình
// này lọc — nên "xem được trang" không có nghĩa "xem được số của mọi tiệm".

/** Xem được bảng KPI chi nhánh (phạm vi chi nhánh do backend cắt). */
export function canViewKpi(staff: Staff | null): boolean {
  if (!staff) return false;
  return hasPermission(ACTION.KpiRead);
}

/** Giao và khoá KPI tháng — chỉ CEO/admin. */
export function canSetTarget(staff: Staff | null): boolean {
  if (!staff) return false;
  return hasPermission(ACTION.KpiTargetWrite);
}

// Quỹ thưởng (Đợt 2) tách quyền y hệt lý do trên, chỉ khác một bậc: XEM TIỀN
// hẹp hơn xem tiến độ (trưởng chi nhánh xem được quỹ tiệm mình, nhân viên
// thường thì không), còn CHỐT TIỀN thì trưởng chi nhánh cũng không có — không
// ai được tự chốt tiền của chính mình. Gắn nút chốt vào canViewFund là phá
// đúng hàng rào đó.

/** Xem quỹ thưởng và sổ giữ chân (phạm vi chi nhánh do backend cắt). */
export function canViewFund(staff: Staff | null): boolean {
  if (!staff) return false;
  return hasPermission(ACTION.KpiFundRead);
}

/** Chốt tiền — kế toán trở lên. Trưởng chi nhánh KHÔNG tự chốt của mình. */
export function canWriteFund(staff: Staff | null): boolean {
  if (!staff) return false;
  return hasPermission(ACTION.KpiFundWrite);
}

// Định mức chi tháng: quyền RIÊNG của kế toán, không nằm trong canSetTarget.
// Quyết định 0190 (CEO chốt `1a` 24/09/2026) tách hẳn hai ô cạnh nhau trên
// cùng một dòng: chỉ tiêu doanh thu do giám đốc giao, định mức chi do kế toán
// nắm. Dùng canSetTarget cho nút sửa định mức là trao luôn cả quyền đặt mức
// chấm cho kế toán.

/** Gõ định mức chi tháng — kế toán. Không kèm quyền giao chỉ tiêu doanh thu. */
export function canWriteExpenseNorm(staff: Staff | null): boolean {
  if (!staff) return false;
  return hasPermission(ACTION.KpiExpenseNormWrite);
}
